import React from 'react';
import { Paper, Box, Typography, ButtonGroup, Button, Chip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TodayIcon from '@mui/icons-material/Today';
import { formatWeekRange, getWeekNumber } from '../plannerUtils';

const WeekNavigator = ({ weekStart, isCurrentWeek, onPrevious, onNext, onToday }) => (
  <Paper elevation={1} className="planner-week-navigator">
    <Box>
      <Typography variant="overline" className="planner-week-eyebrow">
        Week {getWeekNumber(weekStart)}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Typography variant="h6" component="div" className="planner-week-range">
          {formatWeekRange(weekStart)}
        </Typography>
        {isCurrentWeek && <Chip label="Current week" color="primary" size="small" variant="outlined" />}
      </Box>
    </Box>
    <ButtonGroup variant="outlined" size="small">
      <Button startIcon={<ChevronLeftIcon />} onClick={onPrevious}>
        Previous Week
      </Button>
      <Button startIcon={<TodayIcon />} onClick={onToday} disabled={isCurrentWeek}>
        Current Week
      </Button>
      <Button endIcon={<ChevronRightIcon />} onClick={onNext}>
        Next Week
      </Button>
    </ButtonGroup>
  </Paper>
);

export default WeekNavigator;
